app.component("aiCallsCreateView", {
    templateUrl: "app/src/js/components/aiCalls/aiCallsCreate.html",
    controller: "aiCallsCreateController",
    bindings: {
        patientId: "<",
        editItem: "<?",
        hideBackButton: "<?",
        onSave: "&",
        onBack: "&",
        onChange: "&"
    }
});

app.controller("aiCallsCreateController", ["$scope", "ElevenLabsAPI", "Session", "ELEVEN_LABS_AI_TOUR_1261", "$q",
    function ($scope, ElevenLabsAPI, Session, ELEVEN_LABS_AI_TOUR_1261, $q) {
        const ctrl = this;

        $scope.API = ElevenLabsAPI;
        $scope.callObj = {};
        $scope.agentItems = [];
        $scope.allPrompts = [];
        $scope.filteredPrompts = [];
        $scope.availableTimes = [];
        $scope.isSubmitting = false;
        $scope.minDate = moment().format('YYYY/MM/DD');

        ctrl.$onInit = function () {
            if (ctrl.editItem && ctrl.editItem.outbound_call_id) {
                $scope.callObj = angular.copy(ctrl.editItem);
            } else {
                $scope.callObj = {
                    patient_id: ctrl.patientId,
                    _date_scheduled_utc: "",
                };
            }

            // Start the loading process
            $scope.API.isProcessing = true;
            $q.all([$scope.API.getAgents(), $scope.API.getPrompts()])
                .then(values => {
                    $scope.agentItems = values[0].data;
                    $scope.allPrompts = values[1].data;

                    setupForm();
                })
                .finally(() => {
                    $scope.API.isProcessing = false;
                });
        };

        $scope.$watch('callObj', function (newVal) {
            if (newVal && newVal.agent_obj && newVal.prompt_id) {
                ctrl.onChange({
                    data: {
                        agent_id: newVal.agent_obj.agent_id,
                        prompt_id: newVal.prompt_id,
                        date_scheduled_utc: newVal.date_scheduled_utc
                    }
                });
            } else {
                ctrl.onChange({ data: null });
            }
        }, true);

        function setupForm() {
			if (ctrl.editItem && ctrl.editItem.outbound_call_id) {
				const localDate = moment.utc(ctrl.editItem.date_scheduled_utc).toDate();
				$scope.callObj = angular.copy(ctrl.editItem);
				$scope.callObj._date_scheduled_utc = moment(localDate).format("DD/MM/YYYY");
				$scope.callObj.agent_obj = $scope.agentItems.find((t) => t.agent_id === ctrl.editItem.agent_id);
				$scope.updatePromptsForAgent();
				$scope.fetchAvailableTimes();
			} else {
				$scope.callObj = {
					patient_id: ctrl.patientId,
					_date_scheduled_utc: "",
				};
				if ($scope.agentItems && $scope.agentItems.length === 1) {
					$scope.callObj.agent_obj = $scope.agentItems[0];
					$scope.updatePromptsForAgent();
				}
				setTimeout(() => {
					setupOnboard();
				}, 100);
			}
		}

        $scope.updatePromptsForAgent = function () {
            if (!$scope.callObj.agent_obj || !$scope.allPrompts.length) {
                $scope.filteredPrompts = [];
                $scope.callObj.prompt_id = null;
                return;
            }

            const agentPromptIds = $scope.callObj.agent_obj.prompt_id_list || [];

            $scope.filteredPrompts = $scope.allPrompts.filter(p =>
                agentPromptIds.includes(p.prompt_id)
            );

            // If we have prompts, auto-select the first one if current selection is invalid
            if ($scope.filteredPrompts.length > 0) {
                const isCurrentValid = $scope.callObj.prompt_id && agentPromptIds.includes($scope.callObj.prompt_id);
                if (!isCurrentValid) {
                    $scope.callObj.prompt_id = $scope.filteredPrompts[0].prompt_id;
                }
            } else {
                $scope.callObj.prompt_id = null;
            }
        };

        $scope.fetchAvailableTimes = function () {
            $scope.availableTimes = [];
            if (!$scope.callObj._date_scheduled_utc) return;

            const selectedDate = moment($scope.callObj._date_scheduled_utc, "DD/MM/YYYY");
            const startTime = selectedDate.clone().hour(8).minute(0).second(0);
            const endTime = selectedDate.clone().hour(20).minute(0).second(0);
            const bufferTime = moment().add(5, 'minutes');

            let currentSlot = startTime.clone();
            while (currentSlot.isSameOrBefore(endTime)) {
                if (currentSlot.isAfter(bufferTime)) {
                    $scope.availableTimes.push({
                        name: currentSlot.format("h:mm A"),
                        value: currentSlot.clone().utc().format()
                    });
                }
                currentSlot.add(10, 'minutes');
            }

            // A time picked for a previous date (or loaded with the call) is only kept if it is one of
            // this date's slots - otherwise the select shows blank while the old time is still saved.
            if ($scope.callObj.date_scheduled_utc) {
                const current = moment($scope.callObj.date_scheduled_utc);
                const slot = $scope.availableTimes.find((t) => moment(t.value).isSame(current));
                $scope.callObj.date_scheduled_utc = slot ? slot.value : null;
            }
        };

        $scope.onAgentChange = function () {
            $scope.updatePromptsForAgent();
            $scope.fetchAvailableTimes();
        };

        $scope.save = function (callNow = false) {
            // Guard against double submission: ignore further clicks while the call is
            // being scheduled (both buttons are also disabled until it resolves).
            if ($scope.isSubmitting) {
                return;
            }

            const data = {
                practice_id: Session.practice.id,
                agent_id: $scope.callObj.agent_obj.agent_id,
                prompt_id: $scope.callObj.prompt_id,
                date_scheduled_utc: callNow ? null : $scope.callObj.date_scheduled_utc,
                patient_id: ctrl.patientId
            };

            const request = $scope.callObj.outbound_call_id ?
                $scope.API.updateOutboundCall($scope.callObj.outbound_call_id, data) :
                $scope.API.createOutboundCall(data);

            $scope.isSubmitting = true;
            $scope.API.isProcessing = true;
            request.then(() => ctrl.onSave()).finally(() => {
                $scope.API.isProcessing = false;
                $scope.isSubmitting = false;
            });
        };

        function setupOnboard() {
            if(!ELEVEN_LABS_AI_TOUR_1261){
                return;
            }
			introJs
				.tour()
				.setOptions({
					steps: [
						{
							title: 'Select agent',
							element: document.getElementById("agent_selector"),
							intro: "This step focuses on an element",
						},
						{
							title: 'Choose schedule date',
							element: document.getElementById("schedule_date"),
							intro: "This step focuses on an element",
						},
						{
							title: 'Choose schedule time',
							element: document.getElementById("schedule_time"),
							intro: "This step focuses on an element",
						},
					],
					tooltipClass: "intro-customTooltip",
					dontShowAgain: true,
					showBullets: false
				})
				.start();
		}
    }
]);